module.exports = __webpack_public_path__ + "img/editBanner_b.a04570a2.png";